<script lang="ts" setup>
import type {Component} from "#magnolia-layer/types/magnolia-types";
import {vIframeResize} from "~/utils/iframe/resizer";
import {withQuery} from "ufo";

const {
  metadata,
  iframeSrc,
} = defineProps<{
  metadata?: Component;
  iframeSrc: string;
}>();

const { locale } = useI18n()

const localizedFrameSrc = computed(() => {
  return withQuery(iframeSrc, {
    lang: locale.value
  })
})

</script>

<template>
  <div class="iframe-wrapper col-span-full">
    <iframe
        :src="localizedFrameSrc"
        v-iframe-resize
        allow="fullscreen"
        loading="lazy"></iframe>
  </div>
</template>

<style lang="scss" scoped>
.iframe-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: calc(var(--spacing) * 4);
}

iframe {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  display: block;
  border: 0;
  overflow: auto;
  margin-inline: auto;
}
</style>
